import axios from 'axios';

export default class LoginService {
    ControllerName = 'Login';

    // create new user 
    CheckUser(logindata) {
        return axios.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/CheckUser`, logindata).then(res => res)
    }

    // forgot password
    ForgotPassword(logindata) {
        return axios.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/ForgotPassword`, logindata).then(res => res)
    }   
}



